const regexPattern = /\0/g;

export const removeNullValues = (
  customFieldValues: string,
): NonNullable<string> => {
  return customFieldValues.replaceAll(regexPattern, '');
};
